// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'animate.css';
import router from './vue/router'
import './vue/resource/index'
import store from './vue/store/index'
import VuePersist from 'vue-persist'
import './vue/filters'
import socketio from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'

import Menu from './components/shared/Menu'
import ModalPassword from './components/shared/ModalPassword'
import ModalDevices from './components/shared/ModalDevices'
import ModalExport from './components/shared/ModalExport'
import ModalExportSchedule from './components/shared/ModalExportSchedule'
import ModalImport from './components/shared/ModalImport'
import ModalRectify from './components/shared/ModalRectify'
import ModalPermission from './components/shared/ModalPermission'
import ModalLoader from './components/shared/ModalLoader'
import Tap from './components/shared/Tap'
import './vue/mixins'
import ModalComments from './components/shared/ModalComments'


Vue.component('left-menu', Menu);
Vue.component('modal-pass', ModalPassword);
Vue.component('select-device', ModalDevices);
Vue.component('modal-export', ModalExport);
Vue.component('modal-export-schedule',ModalExportSchedule);
Vue.component('modal-import',ModalImport);
Vue.component('modal-rectify', ModalRectify);
Vue.component('modal-permission', ModalPermission);
Vue.component('modal-loader', ModalLoader);
Vue.component('tap-item', Tap);
Vue.component('Modal-Comments', ModalComments)

export const SocketInstance = socketio('https://laosseguridad.com.co:4020', {
  secure: true
});
// export const SocketInstance = socketio('https://36b8-204-199-118-227.ngrok.io', {
//   secure: true
// });
Vue.use(VueSocketIO, SocketInstance)

Vue.use(VueCustomTooltip, {
  name: 'VueCustomTooltip',
  color: '#fff',
  background: '#000',
  borderRadius: 12,
  fontWeight: 400,
  
})


Vue.config.productionTip = false

Vue.use(VuePersist) 
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store: store
})







// WEBPACK FOOTER //
// ./src/main.js